import createIcon from '../../createIcon';

/**
 * @component @name AddAlert
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuMDEgMjAuNTFDMTAuMDEgMjEuNjEgMTAuOSAyMi41IDEyIDIyLjVDMTMuMSAyMi41IDEzLjk5IDIxLjYxIDEzLjk5IDIwLjUxSDEwLjAxWk0xOC44OCAxNi4zMlYxMC41QzE4Ljg4IDcuMjUgMTYuNjMgNC41MyAxMy41OSAzLjgxVjMuMDlDMTMuNTkgMi4yMSAxMi44OCAxLjUgMTIgMS41QzExLjEyIDEuNSAxMC40MSAyLjIxIDEwLjQxIDMuMDlWMy44MUM3LjM3IDQuNTMgNS4xMiA3LjI1IDUuMTIgMTAuNVYxNi4zMkwzIDE4LjQ0VjE5LjVIMjFWMTguNDRMMTguODggMTYuMzJaTTE2IDEyLjUxSDEzVjE1LjUxSDExVjEyLjUxSDhWMTAuNUgxMVY3LjVIMTNWMTAuNUgxNlYxMi41MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AddAlert = createIcon('AddAlert', [
  [
    'path',
    {
      d: 'M10.01 20.51C10.01 21.61 10.9 22.5 12 22.5C13.1 22.5 13.99 21.61 13.99 20.51H10.01ZM18.88 16.32V10.5C18.88 7.25 16.63 4.53 13.59 3.81V3.09C13.59 2.21 12.88 1.5 12 1.5C11.12 1.5 10.41 2.21 10.41 3.09V3.81C7.37 4.53 5.12 7.25 5.12 10.5V16.32L3 18.44V19.5H21V18.44L18.88 16.32ZM16 12.51H13V15.51H11V12.51H8V10.5H11V7.5H13V10.5H16V12.51Z',
      key: '1jlrqm',
    },
  ],
]);

export default AddAlert;
